import { WebformStateCondition } from '@qodly/shared';

export const updateDsCondition = (
  condition: WebformStateCondition,
  oldRef: string,
  newRef: string,
): WebformStateCondition => {
  switch (condition.type) {
    case 'datasource':
      return {
        ...condition,
        path: condition.path === oldRef ? newRef : condition.path,
        value:
          condition.valueType === 'datasource' && condition.value === oldRef
            ? newRef
            : (condition.value as string),
        compareValue:
          condition.compareValueType === 'datasource' &&
          condition.compareValue === oldRef
            ? newRef
            : (condition.compareValue as string),
      };
    case 'privilege':
    case 'currentState':
    case 'parentState':
      if (condition.valueType === 'datasource') {
        return {
          ...condition,
          value:
            condition.value === oldRef ? newRef : (condition.value as string),
        };
      }
      break;
    case 'combination':
      return {
        ...condition,
        conditions: (condition.conditions || []).map((condition) =>
          updateDsCondition(condition, oldRef, newRef),
        ),
      };
  }
  return condition;
};
